<table class="table sort-table">
    <thead>
        <tr>
            @if (model.options.showCheckboxes) {
                <th class="text-center sortable-list-header"></th>
            }
            @for (column of model.options.columns; track column) {
                <th class="text-center sortable sortable-list-header">
                    <a (click)="doSort(column.field)"> {{ column.title }} </a>
                    @if (reverseSort && orderByField === column.field && model.rows.length > 0) {
                        <fa-icon [icon]="faSortDown"></fa-icon>
                    }
                    @if (!reverseSort && orderByField === column.field && model.rows.length > 0) {
                        <fa-icon [icon]="faSortUp"></fa-icon>
                    }
                </th>
            }
        </tr>
    </thead>
    <tbody>
        @if (model.rows.length === 0) {
            <tr>
                <td
                    [colSpan]="model.options.columns.length"
                    class="text-center"
                    translate="SORTABLE_LIST_EMPTY_TEXT_PLACEHOLDER"
                ></td>
            </tr>
        }
        @if (model.rows.length > 0) {
            @for (row of model.rows | orderBy: orderByField : reverseSort; track row) {
                <tr
                    [ngClass]="
                        row === model.selectedRow && model.options.highlightSelectedRow
                            ? 'selected'
                            : row.rowValueInvalid
                              ? 'row-invalid'
                              : ''
                    "
                >
                    @if (model.options.showCheckboxes) {
                        <td>
                            <pace-core-checkbox-input [(model)]="row.isRowSelected"></pace-core-checkbox-input>
                        </td>
                    }
                    @for (column of model.options.columns; track column) {
                        <td (click)="rowClick(row)" class="text-center">
                            {{ get(row, column.field) }}
                        </td>
                    }
                </tr>
            }
        }
    </tbody>
</table>
